import { declareParams, JsonApiRequestError } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createStore, Store } from 'effector';
import { RegistryParams, RegistryQuery } from 'shared/lib';
import { createAuthQuery } from '../auth-http-client';
import { Bonus, bonusSchema, createPaginatedSchema } from '../types';

export type OriginalBonusRegistryParams = {
	sortField?: string | null;
	sortDirection?: string;
	page?: number;
	limit?: number;
	currencies?: string[];
	gameIds?: string[];
	accountIds?: string[];
};

export type BonusRegistryFilters = {
	currencies: string[];
	gameIds: number[];
	accountIds: number[];
};

export type BonusRegistryParams = RegistryParams<BonusRegistryFilters>;

export type BonusRegistryQuery = RegistryQuery<Bonus, BonusRegistryFilters, JsonApiRequestError>;

export const createBonusRegistryQuery = ($accountId?: Store<number | null>): BonusRegistryQuery => {
	const query = createAuthQuery({
		params: declareParams<BonusRegistryParams>(),
		request: {
			method: 'GET',
			url: '/bonus/list',
			query: {
				source: $accountId ?? createStore(null),
				fn: (params, accountId) => ({
					page: params.page,
					limit: params.limit,
					sortField: params.sortField ?? undefined,
					sortDirection: params.sortDirection,
					currencies:
						params.filters.currencies?.length === 0 ? undefined : params.filters.currencies,
					gameIds:
						params.filters.gameIds?.length === 0 ? undefined : params.filters.gameIds.map(String),
					accountIds: [
						...(accountId ? [String(accountId)] : []),
						...params.filters.accountIds.map(String),
					],
				}),
			},
		},
		response: {
			contract: zodContract(createPaginatedSchema(bonusSchema)),
		},
	});

	return query;
};
